import styles from "./CTA.module.css";
import classNames from "classnames";
import { Button } from "../Button";
import { useCallback, useContext } from "react";
import { AppContext } from "../../state";
import { fahrradsucheAGPSSTabName, fahrradsucheWebsitePathName } from "./config.ts";
import { useAnalytics } from "../../tracking/";
import { environmentFromUrlForTracking, getEmployerPortal, getTrackingDomain } from "../../api/";

type CtaProps = {
  id: string;
  variant?: "default" | "forBottomSheet";
};
const devMode = import.meta.env.DEV;

export const CtaButton = (props: CtaProps) => {
  const { id, variant = "default" } = props;
  const analytics = useAnalytics();
  const state = useContext(AppContext);
  const { calculatorEnv, ctaUrl } = state.configuration;
  const environmentForTracking = environmentFromUrlForTracking(window?.location?.hostname, devMode);
  const employerPortal = getEmployerPortal(window?.location?.href, state.configuration.calculatorEnv);
  const domainForTracking = getTrackingDomain(state.configuration.calculatorEnv);
  const handleClick = useCallback(() => {
    if (!window) {
      return;
    }
    if (ctaUrl?.length) {
      window.location.href = ctaUrl;
    } else if (calculatorEnv === "website") {
      window.location.pathname = fahrradsucheWebsitePathName;
    } else {
      window.location.hash = fahrradsucheAGPSSTabName;
    }
    analytics.track({
      name: "click_fachhandel_finden",
      props: { env: environmentForTracking, employer_portal: employerPortal, domain: domainForTracking },
    });
  }, [calculatorEnv, ctaUrl, analytics, employerPortal, environmentForTracking, domainForTracking]);

  const elementClassNames = classNames(styles.cta, { [styles[variant]]: variant !== "default" });

  return <Button id={id} label="searchRetailer" onClick={handleClick} className={elementClassNames}></Button>;
};
